import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { adminApi } from '@/services';
import PeopleIcon from '@mui/icons-material/People';
import SchoolIcon from '@mui/icons-material/School';
import BusinessIcon from '@mui/icons-material/Business';
import MenuBookIcon from '@mui/icons-material/MenuBook';

export const SystemStatsCard = () => {
	const { data: stats, isLoading, error } = useQuery({
		queryKey: ['admin', 'system-stats'],
		queryFn: adminApi.getSystemStats,
		refetchOnWindowFocus: false,
		staleTime: 30000
	});

	if (isLoading) {
		return (
			<Card>
				<CardContent>
					<Typography>Đang tải thống kê hệ thống...</Typography>
				</CardContent>
			</Card>
		);
	}

	if (error) {
		console.error('[SystemStatsCard] Error loading stats:', error);
		return (
			<Card>
				<CardContent>
					<Typography color="error" gutterBottom>
						Lỗi tải thống kê hệ thống
					</Typography>
					<Typography variant="body2" color="text.secondary">
						{error instanceof Error ? error.message : 'Lỗi không xác định'}
					</Typography>
				</CardContent>
			</Card>
		);
	}

	const statItems = [
		{ 
			label: 'Tổng số người dùng', 
			value: stats?.totalUsers || 0, 
			icon: <PeopleIcon fontSize="large" />,
			color: '#1976d2'
		},
		{ 
			label: 'Tổng số sinh viên', 
			value: stats?.totalStudents.toLocaleString() || 0, 
			icon: <SchoolIcon fontSize="large" />,
			color: '#2e7d32'
		},
		{ 
			label: 'Tổng số khoa', 
			value: stats?.totalFaculties || 0, 
			icon: <BusinessIcon fontSize="large" />,
			color: '#ed6c02'
		},
		{ 
			label: 'Tổng số ngành', 
			value: stats?.totalMajors || 0, 
			icon: <MenuBookIcon fontSize="large" />,
			color: '#9c27b0'
		}
	];

	return (
		<Card>
			<CardContent>
				<Typography variant="h6" gutterBottom>
					Thống kê hệ thống
				</Typography>
				<Grid container spacing={2} sx={{ mt: 1 }}>
					{statItems.map((item, index) => (
						<Grid item xs={12} sm={6} md={3} key={index}>
							<Box
								sx={{
									p: 2,
									borderRadius: 2,
									bgcolor: 'background.default',
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
									gap: 1
								}}
							>
								<Box sx={{ color: item.color }}>
									{item.icon}
								</Box>
								<Typography variant="h4" fontWeight="bold">
									{item.value}
								</Typography>
								<Typography variant="body2" color="text.secondary" textAlign="center">
									{item.label}
								</Typography>
							</Box>
						</Grid>
					))}
				</Grid>
			</CardContent>
		</Card>
	);
};
